export default __webpack_public_path__ + "static/media/carriage_remove_bg.f199828c.png";